import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW7201Component } from './kymw7201.component';
import { GetOperationGoodsService } from './api-services/get-operation-goods.service';
import { UpdateOperationGoodsService } from './api-services/update-operation-goods.service';
import { RegistOperationGoodsService } from './api-services/regist-operation-goods.service';
import { CountFixtationService } from './api-services/count-fixtation.service';

/**
 * 運営商品登録画面 モジュール設定クラス
 *
 * @export KYMW7201Module
 * @class KYMW7201Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW7201Component,
  ],
  providers: [
    GetOperationGoodsService,
    UpdateOperationGoodsService,
    RegistOperationGoodsService,
    CountFixtationService
  ],
})

export class KYMW7201Module {

}
